import LegalLayout, { H2, P, UL, PH } from "../LegalLayout";

export default function AGB() {
  return (
    <LegalLayout title="Allgemeine Geschäftsbedingungen (AGB)">
      <H2>§ 1 Geltungsbereich</H2>
      <P>
        Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen dem Anbieter (siehe Impressum) und
        Verbrauchern (§ 13 BGB), die über den Onlineshop MAZARO geschlossen werden. Es gilt deutsches Recht.
      </P>

      <H2>§ 2 Vertragsabschluss</H2>
      <UL
        items={[
          "Die Darstellung der Produkte im Shop ist ein rechtlich verbindliches Angebot zum Kauf („Jetzt sichern“).",
          "Du legst Produkte in den Warenkorb, gibst deine Kontaktdaten ein und schließt die Zahlung über die Kasse (Stripe) ab.",
          "Der Vertrag kommt mit erfolgreichem Abschluss der Zahlung und Anzeige der Bestellbestätigung zustande. Eine E-Mail-Bestätigung senden wir dir zusätzlich zu.",
          "Vor Abschluss der Bestellung werden dir Produkt, Gesamtpreis inklusive Umsatzsteuer, Versandkosten sowie unsere AGB und die Widerrufsbelehrung angezeigt; du musst deren Kenntnisnahme bestätigen.",
        ]}
      />

      <H2>§ 3 Preise und Zahlung</H2>
      <UL
        items={[
          "Alle Preise sind Endpreise inklusive gesetzlicher Umsatzsteuer.",
          <>
            zzgl. <PH>Versandkosten: [Betrag in EUR bzw. „kostenfrei“ — hier eintragen]</PH>
          </>,
          "Die Zahlung erfolgt über die im Bestellprozess angebotenen Zahlungsmittel (Karte, Apple Pay, Google Pay, Link, Klarna u.a. — bereitgestellt durch Stripe).",
        ]}
      />

      <H2>§ 4 Lieferung</H2>
      <PH>
        Liefergebiet: [z.B. nur Deutschland / DE+EU]. Lieferzeit: [z.B. 2–4 Werktage nach Zahlungseingang].
        Versanddienstleister: [z.B. DHL]. Versandkostenregelung siehe § 3 und Versandrichtlinien. — Ohne echte Angaben
        dürfen diese Punkte nicht veröffentlicht werden.
      </PH>

      <H2>§ 5 Eigentumsvorbehalt</H2>
      <P>Die Ware bleibt bis zur vollständigen Bezahlung unser Eigentum.</P>

      <H2>§ 6 Widerrufsrecht</H2>
      <P>
        Als Verbraucher hast du ein gesetzliches Widerrufsrecht; Details findest du in der{" "}
        <a href="/widerruf" className="text-gold underline underline-offset-4">
          Widerrufsbelehrung
        </a>
        .
      </P>

      <H2>§ 7 Gewährleistung</H2>
      <P>
        Es gilt die gesetzliche Mängelhaftung (§§ 434 ff. BGB). Für Verbraucher beträgt die Verjährungsfrist für
        Mängelansprüche bei neuen Waren zwei Jahre ab Ablieferung.
      </P>

      <H2>§ 8 Haftung</H2>
      <P>
        Wir haften unbeschränkt bei Vorsatz und grober Fahrlässigkeit, bei Verletzung von Leben, Körper oder Gesundheit
        sowie nach den Vorschriften des Produkthaftungsgesetzes. Bei leicht fahrlässiger Verletzung wesentlicher
        Vertragspflichten ist die Haftung auf den vorhersehbaren, vertragstypischen Schaden begrenzt.
      </P>

      <H2>§ 9 Online-Streitbeilegung</H2>
      <P>
        Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung bereit:{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="text-gold underline underline-offset-4">
          https://ec.europa.eu/consumers/odr
        </a>
      </P>
      <PH>[Hinweis zur Teilnahme an Verbraucherschlichtungsverfahren ergänzen — wie im Impressum.]</PH>

      <H2>§ 10 Schlussbestimmungen</H2>
      <P>
        Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. Es gilt
        deutsches Recht unter Ausschluss des UN-Kaufrechts.
      </P>
    </LegalLayout>
  );
}
